import type { Route } from "./+types/public.layout";

import { Outlet, redirect } from "react-router";

import makeServerClient, { getSafeUser } from "../lib/supa-client.server";

export async function loader({ request }: Route.LoaderArgs) {
  const [client] = makeServerClient(request);

  const { user } = await getSafeUser(client);

  if (user) {
    throw redirect("/dashboard");
  }

  return {};
}

export default function PublicLayout() {
  return <Outlet />;
}
